<template>
  <div class="read-view-sidebar">
    <button class="read-view-sidebar__back-btn" @click="navigateToRoute()">
      <img
        src="@/assets/icons/left-arrow-icon.png"
        alt="icon"
        class="arrow-back"
      />
    </button>
    <div class="read-view-sidebar__button">
       <the-reactions
        :articleId="articleId"
        :userReaction="userReaction"
        :isArticleReadView="isArticleReadView"
        :isMobileView="isMobileView"
      ></the-reactions> 
    </div>
    <div @click="visibleSaveArticleModal()" class="read-view-sidebar__button">
      <button class="read-view-sidebar__button--btn">
        <img src="@/assets/icons/save-icon.svg" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Save</p>
    </div>
    <div @click="visibleShareArticleModal()" class="read-view-sidebar__button read-view-sidebar__rate-btn">
      <button class="read-view-sidebar__button--btn">
        <img src="@/assets/icons/reply.svg" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Share</p>
    </div>
    <div @click="visibleShareArticleDrawer()" class="read-view-sidebar__button read-view-sidebar__mobile-rate-btn">
      <button class="read-view-sidebar__button--btn read-view-sidebar__mobile-rate-btn--btn">
        <img src="@/assets/icons/reply.svg" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Share</p>
    </div>
    <div @click="toggleActNowModal()" class="read-view-sidebar__button">
      <button class="read-view-sidebar__button--btn">
        <img src="@/assets/icons/act-now-icon.png" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Act now</p>
    </div>
    <div @click="visibleRateArticleDrawer()" class="read-view-sidebar__button read-view-sidebar__mobile-rate-btn">
      <button class="read-view-sidebar__button--btn read-view-sidebar__mobile-rate-btn--btn">
        <img src="@/assets/icons/data_exploration.svg" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Rate</p>
    </div>
    <div @click="visibleCommentDrawer()" class="read-view-sidebar__button read-view-sidebar__mobile-rate-btn">
      <button class="read-view-sidebar__button--btn read-view-sidebar__mobile-rate-btn--btn">
        <img src="@/assets/icons/mark_chat_unread.svg" alt="icon" />
      </button>
      <p class="read-view-sidebar__button--title">Comments</p>
    </div>
  </div>

   <!-- Share article modal -->
   <a-modal
    v-model:visible="showArticleShareModal"
    :footer="null"
    wrapClassName="share-article-modal"
  >
    <article-share-modal
      :title="title"
      :image="image"
      :source="source"
      :url="url"
      :date="date"
      :id="articleId"
      @close-article-share-modal="closeShareArticleModal"
    ></article-share-modal>
  </a-modal>

   <!-- Save article modal -->
   <a-modal
    v-model:visible="showSaveArticleModal"
    :footer="null"
    wrapClassName="save-article-modal"
  >
   <article-save-modal
    :visible="showSaveArticleModal"
    @handle-close="showSaveArticleModal = false"
    :articleId="articleId"
  >
  </article-save-modal>
  </a-modal>

  <!-- Article Read view comment Drawer -->
  <topic-discussion-drawer
    :drawerVisibility="showCommentDrawer"
    :isArticleView="true"
    @close-drawer="closeCommentDrawer()"
  ></topic-discussion-drawer>

  <!-- Share article drawer in mobile screen -->
  <article-share-drawer
    :dynamicClass="dynamicClass"
    :title="title"
    :image="image"
    :source="source"
    :url="url"
    :date="date"
    :id="articleId"
    :visible="showShareArticleDrawer"
    @close-share-article-drawer="closeShareArticleDrawer"
  ></article-share-drawer>

  <!-- Rate article drawer in mobile screen -->
  <a-drawer
    :title="false"
    placement="bottom"
    :closable="false"
    :visible="showRateArticleDrawer"
    :class="[showCloseIcon ? 'rate-article-drawer-close-hide': '', 'rate-article-drawer']"
  >
    <div class="rate-article-container">
      <div class="rate-article-container__header">
        <p>Rate this article</p>
        <i class="icon icon-add_plus" @click="closeRateArticleDrawer()"></i>
      </div>
      <div class="rate-article-container__body rate-article-container-body">
        <article-rating-modal
          :visible="showRateArticleDrawer"
          :articleId="articleId"
          @handle-close="closeRateArticleModal"
          @handleMaskClosable="handleMaskClosable"
        >
        </article-rating-modal>
      </div>
    </div>
  </a-drawer>
  <!-- Act Now Modal -->
  <ActNowFormModal :visible="visibleActNowModal" @handle-close="toggleActNowModal()" :articleId="articleId" />
</template>

<script>
import TheReactions from '../BaseComponents/TheReactions.vue';
import ArticleShareModal from "../BaseComponents/ArticleShareModal.vue";
import ArticleSaveModal from "../BaseComponents/SaveArticleModal.vue";
import ArticleRatingModal from '../BaseComponents/ArticleRatingModal.vue';
import ArticleShareDrawer from "../BaseComponents/ArticleShareDrawer.vue";
import TopicDiscussionDrawer from "../TopicDiscussion/TopicDiscussionDrawer.vue";
import { defineAsyncComponent } from 'vue'

export default{
  components: {
    TheReactions,
    ArticleShareModal,
    ArticleSaveModal,
    ArticleRatingModal,
    ArticleShareDrawer,
    TopicDiscussionDrawer,
    ActNowFormModal: defineAsyncComponent(() => import('@/components/BaseComponents/ActNow/ActNowFormModal.vue'))
  },
  props: {
    articleId: String,
    title: String,
    image: String,
    source: String,
    url: String,
    date: String,
    userReaction: Object,
  },
  data(){
    return {
      showArticleShareModal: false,
      showSaveArticleModal: false,
      showDiscussionSection: false,
      showMessageModal: false,
      showRateArticleDrawer: false,
      showShareArticleDrawer: false,
      dynamicClass: 'activePortfolioTab',
      isMobileView: false,
      isArticleReadView: true,
      showCommentDrawer: false,
      showCloseIcon: false,
      visibleActNowModal: false
    }
  },
  computed: {
    activeKey(){
      return this.$store.getters['discover/getDiscussionCollapseState'];
    },
  },
  watch: {
    showRateArticleDrawer: {
      handler(val) {
        if (val) {
           // when all the elements of the DOM have been loaded.
           this.$nextTick(()=>{
            this.preventTouch();
          })
        }
      },
      immediate: true
    }
  },
  mounted(){
    this.emitter.on('close-article-share-modal', (val)=> {
      this.closeShareArticleModal(val.articleShareModal, val.showMessageModal, val.type);
    });
    this.emitter.on('close-article-save-modal', (val)=> {
      this.closeSaveArticleModal(val);
    })
    if(window.innerWidth < 768){
      this.isMobileView = true;
      this.isArticleReadView = false
    }
  },
  methods: {
    navigateToRoute() {
      this.$router.push({path:'/discover'})
    },
    visibleShareArticleModal() {
      this.showArticleShareModal = true;
    },
    closeShareArticleModal(val, messageModal, type) {
      this.showArticleShareModal = val;
      this.showShareArticleDrawer = val;
      type === 'success' ? this.$showToast({message:'Article shared successfully', type:'success'}) : this.$showToast({message:'Article shared failed.', type:'failure'})
    },
    visibleShareArticleDrawer() {
      this.showShareArticleDrawer = true
    },
    closeShareArticleDrawer() {
      this.showShareArticleDrawer = false
    },
    visibleSaveArticleModal() {
      this.showSaveArticleModal = true;
    },
    closeSaveArticleModal(val) {
      this.showSaveArticleModal = val.modalVisibility;
      this.$showToast({message:val.title, type:val.type})
    },
    visibleRateArticleDrawer() {
      this.showRateArticleDrawer = true
    },
    closeRateArticleDrawer() {
      this.showRateArticleDrawer = false
    },
    visibleCommentDrawer() {
      this.$emit('scrollToComments')
    },
    closeCommentDrawer() {
      this.showCommentDrawer = false;
    },
    handleMaskClosable(showCloseIcon){
      this.showCloseIcon = showCloseIcon
    },
    toggleActNowModal(){
      this.visibleActNowModal = !this.visibleActNowModal
    },
    preventTouch() {
      const scrollElements = document.querySelectorAll('.rate-article-container-body');
      scrollElements.forEach(el => {
        el.addEventListener('touchmove', (e) => {
          if (el.scrollHeight > el.clientHeight) {
            e.stopPropagation();
          }
        }, { passive: false });
      });
    },
    closeRateArticleModal() {
      this.showRateArticleDrawer = false;
    },
  }
}
</script>

<style lang="scss">
.read-view-sidebar {
  padding: 2.8rem 0 0;
  position: sticky;
  top: 8rem;
  z-index: 222;
  background-color: $color-white;
  @include respond(laptop-large) {
    padding-top: 2rem;
  }
  &__back-btn {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 0 !important;
    width: fit-content;
    height: fit-content;
    margin: 0 auto 2.5rem;
    display: block;
    line-height: normal;
    @include respond(tab-port) {
      display: none;
    }
    img {
      width: 3rem;
    }
  }
  &__button {
    width: fit-content;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 3rem;
    &--btn {
      background-color: $color-dark-grey-4;
      width: 6.3rem;
      height: 6.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      cursor: pointer;
      border-radius: 100% !important;
      margin-bottom: 0.4rem;
      @include respond(laptop-large) {
        width: 5rem;
        height: 5rem;
      }
      img {
        width: 2.3rem;
        @include respond(laptop-large) {
          width: 1.7rem;
        }
      }
      .arrow-back {
        display: block;
        transform: rotate(90deg);
        margin-right: 0.5rem;
      }
    }
    &--title {
      font-size: 1.6rem;
      font-family: $font-primary-medium;
      margin-bottom: 0;
      line-height: normal;
      @include respond(laptop-large) {
       font-size: 1.4rem;
      } 
    }
  }
  &__rate-btn {
    display: block;
    @include respond(tab-port) {
      display: none;
    }
  }
  &__mobile-rate-btn {
    display: none;
    &--btn {
      margin: 0 auto;
    }
    @include respond(tab-port) {
      display: block;
    }
  }
}
.rate-article-modal {
  .ant-modal {
    width: 55rem !important;
    top: 8rem;
    .ant-modal-content {
      background-color: rgb(246, 248, 255);
      .ant-modal-close {
        margin: 2.5rem 1.8rem 0 0;
      }
    }
  }
}

.rate-article-drawer {
  .ant-drawer-content-wrapper {
    height: calc(100vh - 60rem) !important;
    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        overflow: hidden;
        .ant-drawer-body {
          height: 100%;
          padding: 0;
          .rate-article-container {
            height: 100%;
            &__header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 3.6rem 3.2rem;
              p {
                font-size: 3rem;
                font-family: $font-primary-bold;
                line-height: normal;
                margin-bottom: 0;
                color: $color-black;
                opacity: 1;
              }
              .icon {
                transform: rotate(45deg);
                display: block;
                cursor: pointer;
                font-size: 2.5rem;
                opacity: 1;
                color: $color-black;
              }
            }
            &__body {
              padding: 0 3.2rem 3.6rem;
              height: calc(100vh - 70.3rem);
              overflow-y: auto;
              overflow-x: hidden;
              &::-webkit-scrollbar {
                width: 0.4rem;
                background-color: transparent;
                border-radius: 3rem;
              }
              &::-webkit-scrollbar-thumb {
                background-color: $color-primary;
                border-radius: 3rem;
              }
              .rate-article-modal-container {
                &__header {
                  display: none;
                }
                &__body {
                  padding: 0;
                  &--input-field-container {
                    margin-bottom: 3rem;
                    &--title {
                      font-size: 2.4rem;
                      opacity: 1;
                    }
                    .ant-radio-group {
                      margin-top: 2rem;
                      margin-bottom: 0.8rem;
                      .ant-radio-wrapper {
                        padding: 0.9rem 1.6rem;
                        .ant-radio {
                          .ant-radio-inner {
                            width: 2rem;
                            height: 2rem;
                          }
                        }
                      }
                      span.ant-radio + * {
                        font-family: $font-primary-regular;
                        font-size: 1.7rem;
                        line-height: normal;
                        padding-left: 0.8rem;
                        margin-top: 0.1rem;
                      }
                    }
                    &--textarea {
                      font-size: 2rem;
                      min-height: 6.3rem;
                      padding: 1.8rem 2rem;
                      line-height: normal;
                    }
                  }
                  &--buttons {
                    flex-direction: column;
                    margin-top: 0;
                    &--btn {
                      height: 7rem;
                      font-size: 2.1rem;
                      width: 100%;
                    }
                  }
                  &--view-ratings-container {
                    .ant-row {
                      .ant-col {
                        flex: 0 0 100%;
                        max-width: 100%;
                      }
                    }
                    .accuracy-credibility-container {
                      margin-bottom: 3rem;
                      &__title {
                        font-size: 2.4rem;
                        line-height: 2.2rem;
                      }
                      &__results-container {
                        .result {
                          margin: 2.5rem 0;
                          .circle {
                            width: 2.4rem;
                            height: 2.4rem;
                            margin-right: 1rem;
                          }
                          h3,
                          h5 {
                            font-size: 2.2rem;
                            line-height: normal;
                          }
                          .images {
                            img {
                              width: 3rem;
                              height: 3rem;
                            }
                            .default-image {
                              width: 2.4rem;
                              height: 2.4rem;
                            }
                          }
                        }
                      }
                    }
                    .see-justifaction-btn {
                      height: 7rem;
                      font-size: 2.1rem;
                      width: 100%;
                      margin: 2rem 0 1.5rem;
                    }
                  }
                }
              }
            }
            .rating-modal-skeleton {
              .ant-skeleton-content {
                padding: 0;
                .ant-skeleton-paragraph {
                  li {
                    height: 3rem;
                    margin: 0 0 2rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.rate-article-drawer-close-hide{
  .ant-drawer-content-wrapper {
    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        .ant-drawer-body {
          .rate-article-container {
            &__header{
              .icon{
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
